import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiListItemButton = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: {
      gap: '8px',
      borderRadius: '8px',
      paddingBlock: '6px',
      paddingInline: '8px',
    },
  },
} satisfies Components<Theme>['MuiListItemButton'];
